module.exports = __webpack_public_path__ + "static/media/cannadatwo.cc30dce6.png";